import { Component, Fragment } from "react";
import LineItemListDisplay from "./LineItemListDisplay";


class LineItemListDisplayGroup extends Component {
    constructor(props) {
        super(props)

        this.state = {
            subtypeUsageByType: {
                "service": false,
                "part": false,
                "other": false,
                "discount": false,
                "tax": false,
            },
        }
    }

    async componentDidMount() {
        const endpoint = DjangoUrls["pricebook:api-pricebookitem-subtypes-usage-by-type"](window.MARKETPLACE_ENTITY_SLUG)

        try {
            const response = await fetch(endpoint)
            const data = await response.json()
            this.setState({ subtypeUsageByType: data })
        } catch (error) {
            console.error("Error fetching subtype choices:", error);
        }
    }


    render = () => {
        const {
            object,
            labelPrefix="",
            formatCurrencyValue,
            useTaxes=false,
            isEstimateLineItem=false,
            isJobLineItem=false,
            isInvoiceLineItem=false,
            isBillLineItem=false,
            isCreditNoteLineItem=false,
            parentLineItems=[],
            parentLineItemFieldName="",
            parentLineItemLabel="",
            isPurchaseOrderLineItem=false,
            isShownToClients=false,
            asServiceSummary=false,
            showPricebookPartDisplay=false,
        } = this.props

        return (
            <Fragment>
                {!isPurchaseOrderLineItem && (
                <LineItemListDisplay
                    fieldName="service_charges"
                    fieldLabel={asServiceSummary ? "Technician Service Summary" : `${labelPrefix}Service Charges`}
                    parent={object}
                    lineItemList={object.service_charges}
                    emptyMessage="No service charges"
                    formatCurrencyValue={formatCurrencyValue}
                    useTaxes={useTaxes}
                    isEstimateLineItem={isEstimateLineItem}
                    isJobLineItem={isJobLineItem}
                    isInvoiceLineItem={isInvoiceLineItem}
                    isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                    isBillLineItem={isBillLineItem}
                    isCreditNoteLineItem={isCreditNoteLineItem}
                    parentLineItems={parentLineItems}
                    parentLineItemFieldName={parentLineItemFieldName}
                    parentLineItemLabel={parentLineItemLabel}
                    isShownToClients={isShownToClients}
                    hasSubtypeChoices={this.state.subtypeUsageByType["service"]}
                ></LineItemListDisplay>
                )}
                {
                    !asServiceSummary && <>
                        <LineItemListDisplay
                            fieldName="parts"
                            fieldLabel={`${labelPrefix}Parts and Materials`}
                            parent={object}
                            lineItemList={object.parts}
                            emptyMessage="No parts and materials charges"
                            formatCurrencyValue={formatCurrencyValue}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            isShownToClients={isShownToClients}
                            showPricebookPartDisplay={showPricebookPartDisplay}
                            hasSubtypeChoices={this.state.subtypeUsageByType["part"]}
                        ></LineItemListDisplay>
                        {!isPurchaseOrderLineItem && (
                        <LineItemListDisplay
                            fieldName="other_charges"
                            fieldLabel={`${labelPrefix}Trip Charges, Diagnostic Fees, etc.`}
                            parent={object}
                            lineItemList={object.other_charges}
                            emptyMessage="No miscellaneous charges"
                            formatCurrencyValue={formatCurrencyValue}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            isShownToClients={isShownToClients}
                            hasSubtypeChoices={this.state.subtypeUsageByType["other"]}
                        ></LineItemListDisplay>
                        )}
                        {!isPurchaseOrderLineItem && !isCreditNoteLineItem && (
                        <LineItemListDisplay
                            fieldName="discounts"
                            fieldLabel={`${labelPrefix}Discounts`}
                            parent={object}
                            lineItemList={object.discounts}
                            emptyMessage="No discounts"
                            formatCurrencyValue={formatCurrencyValue}
                            useTaxes={useTaxes}
                            isEstimateLineItem={isEstimateLineItem}
                            isJobLineItem={isJobLineItem}
                            isInvoiceLineItem={isInvoiceLineItem}
                            isPurchaseOrderLineItem={isPurchaseOrderLineItem}
                            isBillLineItem={isBillLineItem}
                            isCreditNoteLineItem={isCreditNoteLineItem}
                            parentLineItems={parentLineItems}
                            parentLineItemFieldName={parentLineItemFieldName}
                            parentLineItemLabel={parentLineItemLabel}
                            isShownToClients={isShownToClients}
                            hasSubtypeChoices={this.state.subtypeUsageByType["discount"]}
                        ></LineItemListDisplay>
                        )}
                    </>
                }
            </Fragment>
        )
    }
}

export default LineItemListDisplayGroup;
